import { Component, OnInit } from '@angular/core';
import { Idle } from '@ng-idle/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-completed-exit',
  templateUrl: './completed-exit.component.html',
  styleUrls: ['./completed-exit.component.scss']
})
export class CompletedExitComponent implements OnInit {

  constructor(
    private idle: Idle,
    private router: Router 
  ) { }

  Finish() {
    //Cancel extended profile
    this.router.navigate(['/scanticket']);
  }

  ScanAnother() {
    //Save extended profile
    this.router.navigate(['/scananother']);
  }

  ngOnInit() {
    if (!this.idle.isRunning()) {
      this.idle.watch();
    };
  }

}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/completed-exit/completed-exit.component.ts